/**
 * Short actionable tip appended (as an info message) under a failed query's
 * error message, keyed on the classified error category. Only categories
 * with a genuinely useful next step get a tip — syntax errors and the like
 * stay untouched. Copy must stay generic: never echo object names or any
 * other user data.
 */
import type { AnalyticsErrorCategory } from '../../../../core/analytics/analyticsTypes';

export function queryErrorTip(category: AnalyticsErrorCategory): string | undefined {
  switch (category) {
    case 'object_not_found':
      return 'Tip: the object may exist in a different database or schema — check the database selector and try schema-qualifying the name.';
    case 'permission':
      return 'Tip: your account lacks permission for this operation — ask your database administrator to grant access.';
    case 'lock_contention':
      return 'Tip: another session is holding a lock on this data — retry in a moment, or find and close the blocking session.';
    case 'conversion_error':
      return "Tip: a value doesn't match the target data type — check literals and formats (dates, numbers, quoting).";
    default:
      return undefined;
  }
}
